import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

const TestEmail = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_do5dav3',       
        'template_5031186',      
        form.current,
        {
          publicKey: '-QF8KJ648L-QaBEZd', 
        }
      )
      .then(
        (result) => {
          alert('Email sent successfully!');
          console.log('SUCCESS!', result.text);
        },
        (error) => {
          alert('Failed to send email. Please try again later.');
          console.log('FAILED...', error.text);
        }
      );
  };

  return (
    <form ref={form} onSubmit={sendEmail}>
      <label>Name</label>
      <input type="text" name="name" required />

      <label>Email</label>
      <input type="email" name="email" required />

      <label>Message</label>
      <textarea name="message" required />

      <input type="submit" value="Send" />
    </form>
  );
};

export default TestEmail;